import React from 'react'
import {t} from '../../helpers/translate'
import BaseInputComponent from './BaseInputComponent'

class MultiSelectComponent extends BaseInputComponent {

  constructor(props) {
    super(props);

    this.state = {
      sources: props.sources || ['all'],
    };
  }

  updateCheckboxes (val, isChecked) {
    let sources = this.state.sources

    if (val == 'all'){
        sources.splice(0,sources.length)
    }else {
       sources = this.removeItemOnce(sources, 'all')
       sources = this.removeItemOnce(sources, val)

       if(isChecked){
         sources.push(val)
       }
    }

    if(_.isEmpty(sources))
      sources.push('all');

    this.setState({sources: sources});
    this.handleChange(this.state.sources.join(','))
  }

  render() {
    return <div className='multiselect-div'>
      {this.props.options.map((option) => {
        return <div className={`form-group multiselect-line ${this.state.isInvalid ? 'has-error' : ''}`}>
          <label className='form-control-static multiselect-label'>
            <input
              onChange={(event) => {this.updateCheckboxes(option.value, event.target.checked)}}
              type="checkbox"
              checked={this.state.sources.indexOf(option.value) > -1} />
            <span>{t(option.text)}</span>
          </label>
        </div>
      })}
    </div>
  }
}
MultiSelectComponent.displayName = 'MultiSelectComponent';
export default MultiSelectComponent;



// WEBPACK FOOTER //
// ./src/components/common/MultiSelectComponent.js